import React, { useState, useEffect, useMemo } from 'react';
import moment from 'moment';
import {
  Typography,
  Grid,
  AppBar,
  Tabs,
  Tab,
  CircularProgress,
  TextField,
  MenuItem,
  Button,
  Radio,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel
} from '@material-ui/core';
import Select from 'react-select';
import { withStyles } from '@material-ui/core/styles';
import ProviderSearchBar from '../../components/ProviderSearchBar';
import { DateRangePicker } from 'react-date-range';
import { subDays } from 'date-fns';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { useSnackbar } from 'notistack';
import './style.css';

import DateButton from '../../components/DateButton';
import TabPanel from '../../components/TabPanel';
import * as authApi from '../../services/api/auth';
import {
  fetchIncomingWebAppts,
  fetchIncomingProviderAppts,
  fetchOutgoingProviderAppts,
  getProviderApptCountWithDates,
  fetchWebAccountPercentage,
  fetchUtilizationReport,
} from '../../services/api';
import { DateRange } from 'react-date-range';
import fileDownload from 'js-file-download';
import { DateTime } from "luxon";

function ActivityReport(props) {
  const { classes } = props;
  const { enqueueSnackbar } = useSnackbar();

  const [currProvider, setProvider] = useState(null);
  const [currentUser, setCurrentUser] = useState({});
  const [incomingAppts, setIncomingAppts] = useState(null);
  const [apptCount, setApptCount] = useState(null);
  const [outgoingProviderAppts, setOutgoingProviderAppts] = useState(null);
  const [startDate, setStartDate] = useState(
    moment()
      .subtract(90, 'days')
      .format('MM-DD-YYYY')
  );
  const [endDate, setEndDate] = useState(moment().format('MM-DD-YYYY'));
  const [tabPosition, setTabPosition] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [providerList, setProviderList] = useState(null);
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: subDays(new Date(), 7),
      key: 'selection',
    },
  ]);
  const [datePicker, openDatePicker] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [toProvider, setToProvider] = useState({});
  const [reportPreference, setReportPreference] = useState('provider');
  const [selectedLocation, setSelectedLocation] = useState(null);

  const IN = 'incoming';
  const OUT = 'outgoinng';
  const locations = [
    { label: "535 West 110th St #1E, New York, NY 10025", value: "110th" },
    { label: "315 West 70th St #1B, New York, NY 10023", value: "70th" },
    { label: "55 East 87th St #1F, New York, NY 10128", value: "87th" },
    { label: "132 Crosby St, 2nd Floor", value: "crosby" },
    { label: "219 Driggs Avenue, Brooklyn NY 11222", value: "driggs" },
    { label: "347 Third Street, Jersey City, NJ", value: '347' },
    // { label: "61st street", value: '61st' },
    { label: "322 Fairview Avenue Hudson NY 12534", value: "fairview" }
  ];

  useEffect(() => {
    (async () => {
      setLoading(true);
      const user = await authApi.fetchCurrentUser();
      setCurrentUser(user);
      if (user.isProvider) setProvider(user.provider);
      else if (user.isAdministrator) {
        setProvider(user.administrator.providers[0]);
        setProviderList(user.administrator.providers);
      }
      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    if (currProvider) {
      getStats(currProvider.id);
      getCounts(currProvider.id);
    }
  }, [currProvider, startDate, endDate, tabPosition]);

  // Handle report preference change (provider vs location)
  const handleChange = (e) => {
    setReportPreference(e.target.value);
    setToProvider({});
    setSelectedLocation(null);
    setState([
      {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
      },
    ]);
  };

  const handleLocationChange = (selectedOption) => {
    setSelectedLocation(selectedOption);
  };

  const getStats = async id => {
    if (tabPosition === 0) {
      setApptCount(null);
      setState([
        {
          startDate: new Date(),
          endDate: subDays(new Date(), 7),
          key: 'selection',
        },
      ]);
      const inWebAppts = await fetchIncomingWebAppts(id, endDate, startDate);
      //old count
      // const inProvAppts = await fetchIncomingProviderAppts(
      //   id,
      //   endDate,
      //   startDate
      // );
      const outProvAppts = await fetchOutgoingProviderAppts(
        id,
        endDate,
        startDate
      );
      // setIncomingAppts(inWebAppts.count + inProvAppts.count);
      setIncomingAppts(inWebAppts.count);
      setOutgoingProviderAppts(outProvAppts.count);
    }
    else {
      setApptCount(null);
      setState([
        {
          startDate: new Date(),
          endDate: new Date(),
          key: 'selection',
        },
      ]);
    }
  };
  const getCounts = async id => {
    try {
      if (tabPosition === 1) {
        setLoading(true);
        let lastDate =
          state[0].endDate !== null
            ? moment(state[0].endDate).format('YYYY-MM-DD')
            : moment()
                .subtract(1, 'week')
                .format('MM-DD-YYYY');
        let firstDate =
          state[0].startDate !== null
            ? moment(state[0].startDate).format('YYYY-MM-DD')
            : moment().format('MM-DD-YYYY');
        const countData = await getProviderApptCountWithDates(
          id,
          firstDate,
          lastDate
        );
        setApptCount(parseInt(countData[0].count));
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar('Unable to fetch, please try again.');
    }
  };

  const getCountsDate = async () => {
    try {
      if (tabPosition === 1) {
        let lastDate =
          state[0].endDate !== null
            ? moment(state[0].endDate).format('YYYY-MM-DD')
            : moment()
                .subtract(1, 'week')
                .format('MM-DD-YYYY');
        let firstDate =
          state[0].startDate !== null
            ? moment(state[0].startDate).format('YYYY-MM-DD')
            : moment().format('MM-DD-YYYY');
        const countData = await getProviderApptCountWithDates(
          toProvider.id,
          firstDate,
          lastDate
        );
        setApptCount(parseInt(countData[0].count));
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar('Unable to fetch, please try again.');
    }
  };

  const getCountForPro = async () => {
    try {
      if (tabPosition === 1) {
        let lastDate =
          state[0].endDate !== null
            ? moment(state[0].endDate).format('YYYY-MM-DD')
            : moment()
                .subtract(1, 'week')
                .format('MM-DD-YYYY');
        let firstDate =
          state[0].startDate !== null
            ? moment(state[0].startDate).format('YYYY-MM-DD')
            : moment().format('MM-DD-YYYY');
        const countData = await getProviderApptCountWithDates(
          currProvider.id,
          firstDate,
          lastDate
        );
        setApptCount(parseInt(countData[0].count));
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar('Unable to fetch, please try again.');
    }
  };

  const validate = () => {
    let valid = true;
    const nextState = {};
    if (!toProvider.id) {
      nextState.toProvider = 'Required';
      valid = false;
    }
    setValidationErrors(nextState);
    return valid;
  };

  const handleTabPositionChange = (event, newTabPosition) => {
    setTabPosition(newTabPosition);
  };

  const resetDates = () => {
    setStartDate(null);
    setEndDate(moment().format('MM-DD-YYYY'));
  };

  const parseMessage = (count, field) => {
    if (startDate === null && count === 0) {
      switch (field) {
        case IN:
          return 'Qwell is working on connecting you with patients and other providers. Expect to receive your first appointment from Qwell soon.';
        case OUT:
          return 'Keep using Qwell to refer your patients to other providers.';
        default:
          return 'Keep using Qwell to see your activity stats improve.';
      }
    } else if (count === 0) {
      switch (field) {
        case IN:
          return `No stats for appointments made through Qwell from ${moment(
            startDate
          ).format('dddd, MMMM Do YYYY')} to ${moment(endDate).format(
            'dddd, MMMM Do YYYY'
          )}.`;
        case OUT:
          return `You did not make any referrals through Qwell from ${moment(
            startDate
          ).format('dddd, MMMM Do YYYY')} to ${moment(endDate).format(
            'dddd, MMMM Do YYYY'
          )}.`;
        default:
          return 'Keep using Qwell to see your activity stats improve.';
      }
    } else if (field === IN) {
      return 'Referred to you through Qwell';
    } else {
      return `You've referred to other providers on Qwell`;
    }
  };

  const parseCount = count => {
    return count === 0 ? '...' : count;
  };

  const validateStartDate = date => {
    if (moment(date).isAfter(endDate)) {
      enqueueSnackbar('Start date must be before end date.');
    } else {
      setStartDate(moment(date).format('MM-DD-YYYY'));
    }
  };

  const validateEndDate = date => {
    if (moment(date).isBefore(startDate)) {
      enqueueSnackbar('End date must be after start date.');
    } else {
      setEndDate(moment(date).format('MM-DD-YYYY'));
    }
  };

  const getAccountPercentage =async()=>{
    let lastDate =
    state[0].endDate
      ? moment(state[0].endDate).format('YYYY-MM-DD')
      : moment().subtract(1, 'week').format('YYYY-MM-DD');
  
  let firstDate =
    state[0].startDate
      ? moment(state[0].startDate).format('YYYY-MM-DD')
      : moment().format('YYYY-MM-DD');
        console.log(state[0].startDate,state[0].endDate,"Date in state")
        let startDate = firstDate + 'T00:00:00';
        let endDate = lastDate + 'T23:59:59';
        console.log(startDate,endDate,"startDate-endDate");
        const startDateUTC = DateTime.fromISO(startDate, { zone: 'America/New_York' }).toUTC().toISO();
        const endDateUTC = DateTime.fromISO(endDate, { zone: 'America/New_York' }).toUTC().toISO();
        console.log(startDateUTC,endDateUTC,"startDateUTC-endDateUTC");
      // let id =providerSelect.id;
      setLoading(true);
       try {
        let WebAccountPercentage = await fetchWebAccountPercentage(startDateUTC, endDateUTC);
    
        // Ensure data.type is present and check for JSON response
        if (WebAccountPercentage.data?.type?.split('/')[1] === "json") {
          enqueueSnackbar("No data found");
          setLoading(false);
        } else if (WebAccountPercentage.status === 400) {
          enqueueSnackbar("Something went wrong");
          setLoading(false);
        } else {
          setState([
            {
              startDate: new Date(),
              endDate: new Date(),
              key: 'selection',
            },
          ]);
    
          // Trigger the file download
          fileDownload(WebAccountPercentage.data, 'Qwell-Percentage.xlsx');
          
          // Set loading to false after the download
          setLoading(false);
        }
      } catch (error) {
        enqueueSnackbar("An error occurred while fetching data");
        setLoading(false); // Make sure to stop loading on error
      }
  };

  const getUtilizationReport =async()=>{
    try{
      let lastDate =
    state[0].endDate
      ? moment(state[0].endDate).format('YYYY-MM-DD')
      : moment().subtract(1, 'week').format('YYYY-MM-DD');
  
  let firstDate =
    state[0].startDate
      ? moment(state[0].startDate).format('YYYY-MM-DD')
      : moment().format('YYYY-MM-DD');
        // console.log(state[0].startDate,state[0].endDate,"Date in state")
        let startDate = firstDate + 'T00:00:00';
        let endDate = lastDate + 'T23:59:59';
        // console.log(startDate,endDate,"startDate-endDate");
        const startDateUTC = DateTime.fromISO(startDate, { zone: 'America/New_York' }).toUTC().toISO();
        const endDateUTC = DateTime.fromISO(endDate, { zone: 'America/New_York' }).toUTC().toISO();

        const reportPreference = selectedLocation ? 'location' : 'provider';
        const selectedLocationName = selectedLocation ? selectedLocation.label : null;
        const selectedLocationValue = selectedLocation ? selectedLocation.value : null;
        const selectedProviderId = toProvider.id || null;
        setLoading(true);
        let reportData = await fetchUtilizationReport(startDateUTC, endDateUTC, reportPreference, selectedLocationName, selectedLocationValue, selectedProviderId);
        if(reportData && !reportData.data){
          enqueueSnackbar("No data found");
        }
        // console.log(reportData,"reportData")
        setLoading(false);
    }
    catch(err){
      enqueueSnackbar("An error occurred while fetching data");
      setLoading(false); // Make sure to stop loading on error
    }
  }

  return (
    <Grid container classes={{ container: classes.container }}>
      <Grid
        item
        xs={12}
        classes={{ item: classes.header }}
        style={{ paddingBottom: '2em' }}
      >
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item xs={12} className="paddingZero">
            <Typography variant="h2" className={classes.headerText}>
              Activity Reports
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <AppBar
        position="static"
        color="default"
        classes={{ root: classes.appBar }}
      >
        <Tabs value={tabPosition} onChange={handleTabPositionChange}>
          <Tab label="Bookings & Referrals" />
          {/* {currentUser.admin && <Tab label="Patient Visits" />} */}
          <Tab label="Patient Visits" />
          { (currentUser.administrator?.id || currentUser.admin) && <Tab label="Appointment Count"/>}
          { (currentUser.administrator?.id || currentUser.admin) && <Tab label="Utilization Report"/>}
        </Tabs>
      </AppBar>
      {tabPosition === 0 && (
        <TabPanel style={{ height: 'auto' }}>
          {isLoading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            // tabPosition === 0 && (
            <div>
              <div className={classes.controlsContainer}>
                {providerList && (
                  <TextField
                    select
                    className={classes.providerInput}
                    value={currProvider.id}
                    onChange={event => {
                      setLoading(true);
                      setTimeout(() => {
                        setLoading(false);
                      }, 250);
                      const [provider] = providerList.filter(
                        p => p.id === event.target.value
                      );
                      setProvider(provider);
                    }}
                  >
                    {providerList.map(provider => (
                      <MenuItem value={provider.id}>{provider.name}</MenuItem>
                    ))}
                  </TextField>
                )}
                <div className={classes.dateButtonsContainer}>
                  <div className="activityReportDate">
                    <div className={classes.dateBtn}>
                      <DateButton
                        disableFuture
                        selectedDate={startDate}
                        handleDateChange={validateStartDate}
                        label="Select start date"
                      />
                    </div>
                    <div className={classes.dateBtn}>
                      <DateButton
                        disableFuture
                        selectedDate={endDate}
                        handleDateChange={validateEndDate}
                        label="Select end date"
                      />
                    </div>
                    <button onClick={resetDates} className={classes.clearBtn}>
                      All Time
                    </button>
                  </div>
                </div>
              </div>
              <div className={classes.statsContainer}>
                <div className={classes.stat}>
                  <div className={classes.incomingCircle}>
                    <div className={classes.count}>
                      {parseCount(incomingAppts)}
                    </div>
                  </div>
                  <p className={classes.message}>
                    {parseMessage(incomingAppts, IN)}
                  </p>
                </div>

                <div className={classes.stat}>
                  <div className={classes.outgoingCircle}>
                    <div className={classes.count}>
                      {parseCount(outgoingProviderAppts)}
                    </div>
                  </div>
                  <p className={classes.message}>
                    {parseMessage(outgoingProviderAppts, OUT)}
                  </p>
                </div>
              </div>
            </div>
            // )
          )}
        </TabPanel>
      )}
      {tabPosition === 1 && (
        <TabPanel>
          {isLoading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <div className="provider-search-input">
              {currentUser.admin && (
                <ProviderSearchBar
                  label="Select Provider"
                  name="toProvider"
                  placeholder="Search for a provider..."
                  errorMessage={validationErrors.toProvider}
                  style={{ width: '40%' }}
                  onSelect={provider => {
                    if (provider) {
                      setValidationErrors({
                        ...validationErrors,
                        toProvider: false,
                      });
                    }
                    setToProvider(provider || {});
                  }}
                  from="patientVisit"
                  // className={classes.selectInput}
                />
              )}
              <div className={classes.customDatePicker}>
                <div className={classes.datePickerUi}>
                  <div className="custom-calendar">
                    <DateRangePicker
                      editableDateInputs={false}
                      showSelectionPreview={true}
                      onChange={item => setState([item.selection])}
                      moveRangeOnFirstSelection={false}
                      ranges={state}
                      months={1}
                      ariaLabels={{
                        monthPicker: 'month picker',
                        yearPicker: 'year picker',
                        prevButton: 'previous month button',
                        nextButton: 'next month button',
                      }}
                    />
                  </div>
                </div>
              </div>
              {currentUser.admin ? (
                <div className="responsive-circle">
                  <div className={classes.statsContainer}>
                    <div className="circle-right">
                      <div className={classes.stat}>
                        <div className={classes.incomingCircle}>
                          <div className={classes.count}>
                            {toProvider.id !== undefined ? apptCount : 0}
                          </div>
                        </div>
                        <p className="circle-right-text">Patient Visits</p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="responsive-circle">
                  <div className={classes.statsContainer}>
                    <div className="circle-right">
                      <div className={classes.stat}>
                        <div className={classes.incomingCircle}>
                          <div className={classes.count}>{apptCount}</div>
                        </div>
                        <p className="circle-right-text">Patient Visits</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <Grid item xs={12} lg={6} className="activityReportSearchBtn">
                {currentUser.admin ? (
                  <Button
                    className=" custom-update-btn"
                    disabled={toProvider.id !== undefined ? false : true}
                    color="primary"
                    variant="contained"
                    onClick={getCountsDate}
                    onClickValidation={validate}
                  >
                    Search
                  </Button>
                ) : (
                  <Button
                    className=" custom-update-btn"
                    color="primary"
                    variant="contained"
                    onClick={getCountForPro}
                    // onClickValidation={validate}
                  >
                    Search
                  </Button>
                )}
              </Grid>
            </div>
          )}
        </TabPanel>
      )}
        {tabPosition ===2 &&  (currentUser.administrator?.id || currentUser.admin) && (
        <TabPanel>
          {isLoading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <div className="provider-search-input" style={{display:"flex",justifyContent:"space-around"}}>
              <div className={classes.customDatePicker}>
                <div className={classes.datePickerUiChange}>
                  <div className="custom-calendar">
                    <DateRange
                      editableDateInputs={true}
                      onChange={item => setState([item.selection])}
                      moveRangeOnFirstSelection={false}
                      ranges={state}
                      
                    />
                  </div>
                </div>
              </div>
        
           
              <Grid item xs={12} lg={6} className="activityReportSearchBtn" style={{alignSelf:"flex-end"}}>
             
                  <Button
                    className=" custom-update-btn"
                    
                    // disabled={toProvider.id !== undefined ? false : true}
                    color="primary"
                    variant="contained"
                    onClick={()=>getAccountPercentage()}
                    onClickValidation={validate}
                  >
                    Submit
                  </Button>
              
              </Grid>
            </div>
            
          ) 
          }
        </TabPanel>
      )}
      {/* {tabPosition ===3 &&  (currentUser.administrator?.id || currentUser.admin) && (
        <TabPanel>
          {isLoading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <>
            <div style={{margin: "15px 0"}}>
            <FormControl component="fieldset" variant="filled">
                            <FormLabel className={classes.insuranceLabel} component="legend">
                            Choose Your Preference
                            </FormLabel>
                            <RadioGroup
                              row
                              aria-label="preference"
                              name="preference"
                              value={reportPreference}
                              onChange={handleChange}
                            >
                              <FormControlLabel
                                value="provider"
                                control={<Radio />}
                                label="Provider"
                              />
                              <FormControlLabel
                                value="location"
                                control={<Radio />}
                                label="Location"
                              />
                            </RadioGroup>
                          </FormControl>
            </div>
            { reportPreference === 'provider' ? (<ProviderSearchBar
                  label=""
                  name="toProvider"
                  placeholder="Search for a provider"
                  errorMessage={validationErrors.toProvider}
                  // style={{ width: '40%' }}
                  onSelect={provider => {
                    if (provider) {
                      setValidationErrors({
                        ...validationErrors,
                        toProvider: false,
                      });
                    }
                    setToProvider(provider || {});
                  }}
                  from="utilityReport"
            />)
            : (
            <div style={{width: "50%", marginBottom: "50px"}}>
              <Select
              value={selectedLocation}
              onChange={handleLocationChange}
  options={locations}
  noOptionsMessage={() => <div>No options available.</div>}
  isClearable
  isDisabled={false}
  isSearchable
  placeholder="Search for a location"
  styles={{
    control: (base) => ({
      ...base,
    }),
    menu: (base) => ({
      ...base,
      zIndex: 999,
    }),
    menuList: (base) => ({
      ...base,
      zIndex: 999,
    }),
  }}
/>
            </div>
            )
            }
            <div className="provider-search-input" style={{display:"flex",justifyContent:"space-around"}}>
              <div className={classes.customDatePicker}>
                <div className={classes.datePickerUiChange}>
                  <div className="custom-calendar">
                    <DateRange
                      editableDateInputs={true}
                      onChange={item => setState([item.selection])}
                      moveRangeOnFirstSelection={false}
                      ranges={state}
                      
                    />
                  </div>
                </div>
              </div>
        
           
              <Grid item xs={12} lg={6} className="activityReportSearchBtn" style={{alignSelf:"flex-end"}}>
             
                  <Button
                    className=" custom-update-btn"
                    disabled={(toProvider.id || selectedLocation)  ? false : true}
                    color="primary"
                    variant="contained"
                    // onClickValidation={validate}
                    onClick={()=>getUtilizationReport()}
                  >
                    Submit
                  </Button>
              
              </Grid>
            </div>
            </>
          ) 
          }
        </TabPanel>
      )} */}
    </Grid>
  );
}

const styles = theme => ({
  controlsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    padding: '3em',
  },
  appBar: {
    zIndex: 10,
  },
  header: {
    paddingBottom: '3em',
  },
  headerText: {
    fontWeight: 'normal',
    fontSize: '1.8em',
    lineHeight: '1.2em',
    color: '#1C1C1C',
  },
  dateButtonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    marginBottom: '10px',
  },
  providerInput: {
    margin: '30px 8px 0 0',
  },
  dateBtn: {
    marginLeft: '5px',
    marginRight: '5px',
  },
  clearBtn: {
    height: 'fit-content',
    alignSelf: 'flex-end',
    padding: '3px',
    margin: '0 20px 11px 15px',
  },
  statsContainer: {
    paddingTop: '50px',
    paddingBottom: '100px',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center',
  },
  stat: {
    display: 'flex',
    flexDirection: 'row',
    padding: '1.5vw',
    marginLeft: '8%',
    marignRight: '8%',
    flexWrap: 'wrap',
  },
  outgoingCircle: {
    position: 'relative',
    display: 'flex',
    width: '150px',
    height: '150px',
    borderRadius: '50%',
    backgroundColor: '#D7EDF9',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#001CB0',
  },
  incomingCircle: {
    position: 'relative',
    display: 'flex',
    width: '150px',
    height: '150px',
    borderRadius: '50%',
    backgroundColor: '#001CB0',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#D7EDF9',
  },
  count: {
    position: 'absolute',
    alignSelf: 'center',
    fontSize: '36px',
  },
  message: {
    paddingLeft: '18px',
    fontSize: '18px',
    alignSelf: 'center',
  },
  customDatePicker: {
    position: 'relative',
  },
  datePickerUi: {
    position: 'absolute',
    zIndex: '11',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
  circularProgress: {
    marginLeft: 0,
    marginRight: theme.spacing.unit,
  },
  datePickerUiChange: {
    width:"100% !important",
      zIndex: '11',
  },
  insuranceLabel: {
    fontWeight: 'bold',
  }
});

export default withStyles(styles)(ActivityReport);
